/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "../../../../components/MKBox";
import MKTypography from "../../../../components/MKTypography";

function Contact() {
  return (
    <MKBox component="section" bgColor="grey-100" borderRadius="md" py={{ xs: 3, md: 4 }} px={{ xs: 2, sm: 2 }} my={0}>
      <Grid container alignItems="center">
        <Grid item align="center" xs={12} md={12}>
          <MKTypography variant="h4">Contact</MKTypography>
          <br />
          <MKTypography variant="body2" mb={3}>
            Lets get in touch. Come visit our SubReddit and join our Telegram! Links in the header above.
          </MKTypography>
          <MKTypography variant="body2" mb={3}>
            If you feel inclined to Donate (will be used only for funding WED things)
          </MKTypography>
          <MKTypography variant="body2" mb={3}>
            ETH: 0x05C73b2f42AE86C69F9A9fCB0d6de75821117bb4
          </MKTypography>
          <MKTypography variant="body2" mb={3}>
            BTC: 1JFBzJ2G3cYrMGvU2v5CDwNr75yY4hY1B3
          </MKTypography>
          <MKTypography variant="body2" mb={3}>
            LTC: LYQmuV3dpWLxjn5RSkZZ3ZFJLuAUBEQENu
          </MKTypography>
          <MKTypography variant="body2" mb={3}>
            DOGE: DDQTNAaVhXmKqJkTwmPi6J4ySxy4kPTJNJ
          </MKTypography>
        </Grid>
      </Grid>
    </MKBox>
  );
}

export default Contact;
